import { useState as h, useMemo as b, useEffect as p } from "react";
import { getCellTime as g } from "./atoms-v259.js";
import { getCellUID as w } from "./atoms-v261.js";
import v from "./atoms-v21158.js";
import x from "./atoms-v21147.js";
import $ from "./atoms-v21159.js";
function d(t, e) {
  const n = new Map(t ?? /* @__PURE__ */ new Map());
  for (const r of e || [])
    n.set(`${r.year}-${r.month}-${r.day}`, r);
  return n;
}
function C(t, e, n, r) {
  if (!n)
    return !1;
  const u = t * 12 + e + 1, s = n.getFullYear() * 12 + n.getMonth() + 1;
  return (u - s) % r === 0;
}
function F(t, e, n, r) {
  const u = t * 12 + e + 1, s = n.getFullYear() * 12 + n.getMonth() + 1, c = (u - s) % r;
  return $(new Date(t, e, 1), c);
}
function y(t, e) {
  return e ? g(e) >= g(t) : !1;
}
function I({
  batchSize: t,
  dataSource: e,
  initialStartDate: n,
  isLoading: r,
  onFetchNextData: u
}) {
  const [s, f] = h(/* @__PURE__ */ new Map()), c = b(() => Array.from(s.keys()).at(-1), [s]), [a, M] = h([]);
  p(() => {
    f((o) => d(o, e));
  }, []), p(() => {
    f((o) => d(o, e));
  }, [e]), p(() => {
    if (!a.length || r)
      return;
    const o = [...a], m = () => {
      const l = o.shift();
      return l ? y(l.endAt, c) ? m() : l : null;
    }, i = m();
    i && u(i), M(o);
  }, [a, r, c]);
  function A(o, m) {
    const i = F(o, m, n, t), l = w(i), B = w(v(x(i, t), 2));
    M((Q) => [...Q, { endAt: B, startAt: l }]);
  }
  function D() {
    f(() => /* @__PURE__ */ new Map());
  }
  return {
    addBatchToQueue: A,
    buildNextDataStore: d,
    dataStore: s,
    isBatchResolved: y,
    isMultipleOfBatchSize: C,
    lastEndDate: c,
    queue: a,
    reset: D
  };
}
export {
  d as buildNextDataStore,
  F as getBatchStartAt,
  y as isBatchResolved,
  C as isMultipleOfBatchSize,
  I as useDataManager
};
